import React, { FC, useEffect, useMemo, useState } from "react";
import { useEndpoints } from "../../hooks/useEndpoints";
import { useLocation } from "react-router-dom";
import { useSimpleForm } from "../../hooks/useSimpleForm";
import CustomCard from "../../shared/Card/CustomCard";
import Typhography from "../../shared/Typhography/Typhography";
import CustomPasswordInput from "../../shared/CustomPasswordInput/CustomPasswordInput";
import CustomButton from "../../shared/CustomButton/CustomButton";
import { useToastAlert } from "../../hooks/useToastAlert/useToastAlert";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { useMe } from "../../hooks/useMe";
import HeaderLogin from "../../shared/HeaderLogin/HeaderLogin";
import FooterLogin from "../../shared/FooterLogin/FooterLogin";
import "./ConfirmUser.scss";

interface IConfirmUser {}

const ConfirmUser: FC<IConfirmUser> = () => {
  const location = useLocation();
  const { resetMe } = useMe();
  const { confirmUser } = useEndpoints();

  const { form, handleEventInputChange, handleChange } = useSimpleForm({
    password: "",
    confirmPassword: "",
    token: "",
  });
  const toastAlert = useToastAlert();
  const [isLaoding, setisLaoding] = useState(false);
  const { navigate } = useCustomNavigate();

  const securityPassword = useMemo(() => {
    const conditions = [
      /\d/.test(form.password),
      // eslint-disable-next-line
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(form.password),
      form.password.length >= 10,
    ];
    const trueConditions = conditions.filter(Boolean).length;
    return {
      percentual: Number((trueConditions / conditions.length) * 100).toFixed(0),
      number: trueConditions,
      label:
        trueConditions === 0 || trueConditions === 1
          ? "Bassa"
          : trueConditions === 2
          ? "Media"
          : "alta",
      colorLine:
        trueConditions === 0 || trueConditions === 1
          ? "error"
          : trueConditions === 2
          ? "warning"
          : "success",
    };
  }, [form.password]);

  useEffect(() => {
    (async () => {
      try {
        const query = new URLSearchParams(location.search);
        const token = query.get("confirmToken");
        if (!token) {
          return;
        }
        handleChange("token", token);
      } catch (error) {
        console.error("error", error);
      }
    })();
    // eslint-disable-next-line
  }, [location.search]);

  const handleConfirmCoach = async () => {
    setisLaoding(true);
    try {
      resetMe();
      await confirmUser(form);
      navigate("GYM_CONFIRMED");
    } catch (error) {
      console.error("error", error);
      toastAlert({
        type: "error",
        message: "Errore conferma password",
      });
    } finally {
      setisLaoding(false);
    }
  };

  const isConfirmButtonDisabled = () =>
    !form.password || form.password !== form.confirmPassword;

  return (
    <div className="container__login">
      <div className="container__header">
        <HeaderLogin />
        <div id="container-form" className="container__form">
          <CustomCard>
            <Typhography className="pb-3" size="bold-24">
              Crea la tua password
            </Typhography>
            <Typhography className="pb-32" size="regular-16">
              Una password per accedere a i servizi di Leopart
            </Typhography>

            <CustomPasswordInput
              label="Inserisci la tua nuova password"
              placeholder="password"
              className="mb-2"
              value={form.password}
              onChange={(event) => handleEventInputChange("password", event)}
            />
            <div className="container__indicator__confirm__password">
              <Typhography
                className="label__indicator"
                type="span"
                size="bold-12"
              >
                {securityPassword.label}
              </Typhography>
              <div className="indicator">
                <div
                  className={`line line__${securityPassword.colorLine}`}
                  style={{
                    width: `${securityPassword.percentual}%`,
                  }}
                />
              </div>
            </div>
            <ul>
              <li>
                <Typhography type="span" size="bold-12">
                  Usa minimo 10 caratteri
                </Typhography>
              </li>
              <li>
                <Typhography type="span" size="bold-12">
                  Includi almeno un numero
                </Typhography>
              </li>
              <li>
                <Typhography type="span" size="bold-12">
                  Includi almeno un simbolo (!@#$%^*-_+=)
                </Typhography>
              </li>
            </ul>

            <CustomPasswordInput
              label="Conferma la password"
              placeholder="Ripeti la tua nuova password"
              className="pb-32"
              value={form.confirmPassword}
              onChange={(event) =>
                handleEventInputChange("confirmPassword", event)
              }
            />

            <CustomButton
              isLoading={isLaoding}
              disabled={isConfirmButtonDisabled()}
              fullWidth
              onClick={handleConfirmCoach}
            >
              Crea la tua password
            </CustomButton>
          </CustomCard>
        </div>
      </div>
      <div className="container__footer">
        <FooterLogin />
      </div>
    </div>
  );
};

export default ConfirmUser;
